class NavigationMobile {
	constructor() {
		this.navigationMobile();
	}

	navigationMobile() {
		// showNavigationMobile('.toggle', '.navigation-mobile');
		// selectNavItem('navigation-mobile', '', 0);
		disabledLinks('navigation-mobile', 'disabled');
		navigationMobileSubmenu();
		parentMobileNavItem();
		newsActivatedNavItem();

		function disabledLinks(navigation, className) {
			const links = document.querySelectorAll(`.${navigation} a.${className}`);
			links.forEach(link => {
				link.removeAttribute('href');
			})
		}

		/*function showNavigationMobile(toggle, navigation) {
			const toggleElement = document.querySelector(toggle);
			const navigationElement = document.querySelector(navigation);

			const overlayElement = document.createElement('div');
			overlayElement.id = 'navigation-overlay';
			// document.querySelector('.ccm-page').appendChild(overlayElement);
			document.body.appendChild(overlayElement);
			const overlay = document.getElementById('navigation-overlay');

			if (toggleElement && navigationElement) {
				toggleElement.addEventListener('click', () => {
					navigationElement.classList.toggle('open');
					toggleElement.classList.toggle('toggle-close');
					document.body.classList.toggle('navigation-no-scroll');
					overlay.classList.toggle('navigation-show-overlay');
				});
			}

			if (overlay) {
				overlay.addEventListener('click', () => {
					navigationElement.classList.toggle('open');
					toggleElement.classList.toggle('toggle-close');
					document.body.classList.toggle('navigation-no-scroll');
					overlay.classList.toggle('navigation-show-overlay');
				});
			}
		}*/

		function selectNavItem(navClass, page, navPosition) {
			const urlAll = document.URL;
			const beginPosition = urlAll.lastIndexOf("/");
			const endPosition = urlAll.length;
			const urlPart = urlAll.substring(beginPosition + 1, endPosition);

			if (urlPart === page) {
				document.querySelectorAll("." + navClass + " > ul > li")[navPosition].classList.add("active");
				document.querySelectorAll("." + navClass + " > ul > li")[navPosition].querySelector("a").classList.add("active");
			}
		}

		function navigationMobileSubmenu() {
			const toggles = document.querySelectorAll('.navigation-mobile li.has-submenu .menu-link .submenu-icon');

			for (let i = 0; i < toggles.length; i++) {
				toggles[i].addEventListener('click', function (event) {
					event.preventDefault();
					const submenu = this.parentElement.nextElementSibling;
					submenu.classList.toggle('submenu-open');
					this.classList.toggle('submenu-open');
				});
			}
		}

		function parentMobileNavItem() {
			const submenuItems = document.querySelectorAll('.navigation-mobile .menu .has-submenu .submenu .menu-item');

			for (let i = 0; i < submenuItems.length; i++) {
				if (submenuItems[i].classList.contains('active')) {
					const parentItem = submenuItems[i].closest('.has-submenu');
					parentItem.classList.add('active');
				}
			}
		}

		function newsActivatedNavItem() {
			const sections = {
				section1: {
					slug: 'servisni-spolecnost-odpady-olomouckeho-kraje',
					navPosition: 1
				},
				section2: {
					slug: 'spolek-odpady-olomouckeho-kraje',
					navPosition: 2
				},
				section3: {
					slug: 'krajsky-urad-oddeleni-odpadoveho-hospodarstvi',
					navPosition: 3
				},
				section4: {
					slug: 'trideni-a-recyklace',
					navPosition: 4
				},
				section5: {
					slug: 'predchazeni-vzniku-odpadu',
					navPosition: 5
				},
				section6: {
					slug: 'poradenstvi-starostum',
					navPosition: 6
				}
			};
			const navItems = document.querySelectorAll('.navigation-mobile .menu > .menu-item');
			const url = document.URL;
			let slug3 = url.split('/')[3];
			let slug4 = url.split('/')[4];

			if (slug3 === 'aktuality' || slug4 === 'aktuality') {
				for (let i = 1; i <= 6; i++) {
					if (slug3 === sections['section' + i].slug) {
						navItems[sections['section' + i].navPosition].classList.add('active');
						navItems[sections['section' + i].navPosition].querySelector('ul > .menu-item:first-child').classList.add('active');
					}
				}
			}
		}
	}
}

new NavigationMobile();
